import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

import { cn } from "@/lib/chillnn/cn";
import { SnackSnsColor, SnackSnsType } from "@/lib/gql/__generated__/graphql";

import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card/hover-card";
import Facebook from "@/components/ui/icon/sns/facebook";
import Instagram from "@/components/ui/icon/sns/instagram";
import Line from "@/components/ui/icon/sns/line";
import Note from "@/components/ui/icon/sns/note";
import Threads from "@/components/ui/icon/sns/threads";
import Tiktok from "@/components/ui/icon/sns/tiktok";
import X from "@/components/ui/icon/sns/x";
import Youtube from "@/components/ui/icon/sns/youtube";

import type { SnackBlocksFormModelMethodsType } from "../../../../../../model/usecase/use-create-snack-layout-settings-form-model/methods";

type Props = {
	snsIcons: SnackBlocksFormModelMethodsType["SNSMethods"]["snsIcons"];
	snsIcon: SnackBlocksFormModelMethodsType["SNSMethods"]["snsIcons"]["value"][number];
	snsColor: SnackBlocksFormModelMethodsType["SNSMethods"]["snsColor"];
	activateModal: SnackBlocksFormModelMethodsType["SNSMethods"]["activateModal"];
};

export const SelectedSNSIconsItem = ({ snsIcon, snsIcons, snsColor, activateModal }: Props) => {
	const { setNodeRef, listeners, attributes, transform, isDragging } = useSortable({
		id: snsIcon.snsType.value,
	});

	const { snsType } = snsIcon;
	// URLが設定されていない場合
	const isURLNotSet = !!snsIcon.url.error;

	const selectedSNSIconLength = snsIcons.value.filter((item) => item.selected.value).length;

	return (
		<HoverCard open={isURLNotSet}>
			<HoverCardTrigger>
				<button
					type="button"
					className={cn(
						snsColor.value === SnackSnsColor.White ? "text-white" : "text-black",
						isDragging ? "cursor-grabbing" : "cursor-grab",
						selectedSNSIconLength === 2 ? "mx-6" : selectedSNSIconLength === 4 ? "mx-4" : "mx-1",
						"p-2 hover:opacity-80",
					)}
					ref={setNodeRef}
					style={{
						transform: CSS.Transform.toString(transform),
					}}
					{...attributes}
					{...listeners}
				>
					{snsType.value === SnackSnsType.Facebook ? (
						<Facebook size="lg" />
					) : snsType.value === SnackSnsType.Instagram ? (
						<Instagram size="lg" />
					) : snsType.value === SnackSnsType.Twitter ? (
						<X size="lg" />
					) : snsType.value === SnackSnsType.Youtube ? (
						<Youtube size="lg" />
					) : snsType.value === SnackSnsType.Line ? (
						<Line size="lg" />
					) : snsType.value === SnackSnsType.Note ? (
						<Note size="lg" />
					) : snsType.value === SnackSnsType.Tiktok ? (
						<Tiktok size="lg" />
					) : snsType.value === SnackSnsType.Threads ? (
						<Threads size="lg" />
					) : null}
				</button>
			</HoverCardTrigger>
			{isURLNotSet && (
				<HoverCardContent
					onClick={() => activateModal()}
					side={"top"}
					align={"center"}
					sideOffset={14}
					className="w-64 cursor-pointer hover:bg-zinc-100"
				>
					{<p className="text-error-600">{snsIcon.url.error}</p>}
				</HoverCardContent>
			)}
		</HoverCard>
	);
};

SelectedSNSIconsItem.displayName = "SelectedSNSIconsItem";
